import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../store";
import { fetchArtists as fetchArtistsThunk, selectArtists, selectArtistsLoading } from "../store/slices/artistsSlice";

export const useArtists = () => {
  const dispatch = useDispatch<AppDispatch>();
  const artistsData = useSelector(selectArtists);
  const loading = useSelector(selectArtistsLoading);

  const fetchArtists = () => {
    dispatch(fetchArtistsThunk());
  };

  return {
    artistsData,
    loading,
    fetchArtists,
  };
};
